import { render, staticRenderFns } from "./SingleLayerAttributesInfos.vue?vue&type=template&id=11c8ac72&scoped=true"
import script from "./SingleLayerAttributesInfos.vue?vue&type=script&lang=ts"
export * from "./SingleLayerAttributesInfos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c8ac72",
  null
  
)

export default component.exports